import { render, staticRenderFns } from "./SavingsReportVideo.vue?vue&type=template&id=1da228b0&"
import script from "./SavingsReportVideo.vue?vue&type=script&lang=js&"
export * from "./SavingsReportVideo.vue?vue&type=script&lang=js&"
import style0 from "./SavingsReportVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports